import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import PageHeader from "../../../components/ui/pageHeader/PageHeader";
import PageLoader from "../../../components/ui/pageLoader/PageLoader";
import PageEmpty from "../../../components/ui/pageEmpty/PageEmpty";

import ProfileSettingsCard from "./components/ProfileSettingsCard";
import PasswordSettingsCard from "./components/PasswordSettingsCard";
// import SessionsCard from "./components/SessionsCard";
import MFASettingsCard from "./components/MFASettingsCard";

import {
  getMySettings,
  getSessions,
} from "../../../redux/features/settings/settingsSlice";

import { HiOutlineCog6Tooth } from "react-icons/hi2";

import "./SettingsPage.css";

export default function SettingsPage() {
  const dispatch = useDispatch();

  const { user, isLoading, error, success } = useSelector(
    (state) => state.settings,
  );

  useEffect(() => {
    dispatch(getMySettings());
    dispatch(getSessions());
  }, [dispatch]);

  if (isLoading && !user) {
    return <PageLoader title="Instellingen laden..." />;
  }

  if (!user) {
    return (
      <div className="settings-page">
        <PageHeader
          eyebrow="POWER"
          title="Instellingen"
          description="Beheer je account en beveiliging."
        />

        <PageEmpty
          icon={<HiOutlineCog6Tooth />}
          title="Instellingen niet beschikbaar"
          description={error || "Je instellingen konden niet geladen worden."}
        />
      </div>
    );
  }

  return (
    <div className="settings-page">
      <PageHeader
        eyebrow="POWER"
        title="Instellingen"
        description="Account, beveiliging, sessies en MFA."
      />

      {error && <div className="settings-page__error">{error}</div>}
      {success && <div className="settings-page__success">{success}</div>}

      <div className="settings-page__grid">
        <div className="settings-page__main">
          <ProfileSettingsCard user={user} />
          {/* <SessionsCard /> */}
        </div>

        <div className="settings-page__side">
          <PasswordSettingsCard user={user} />
          <MFASettingsCard user={user} />
        </div>
      </div>
    </div>
  );
}
